import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const currentUser = useSelector((state) => state.currentUser);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!currentUser) {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
        }

        // If there are children, render them. Otherwise, render the component.
        // This makes the PrivateRoute flexible for both patterns.
        return children ? children : <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
